// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"081dbf59","164":"0e6b6ef6","459":"650eb80e","778":"9ee377db","815":"186fcde8","862":"f86b55b1"}[chunkId] + ".chunk.js";
};